import Vue from 'vue';
import Vuex from 'vuex';
import PersistedState from 'vuex-persistedstate'

Vue.use(Vuex);

export const store = new Vuex.Store({
  plugins : [
    PersistedState()
  ],
  state : {
    is_authenticated  : true,
    auth_key          : '',
    user              : {},
    tray              : [],
    tray_qty          : 0,
    printer_uri       : 'http://212.159.121.4:3040',
    printer_uri_local : 'http://127.0.0.1:3040',
    report_date_from  : '',
    report_date_to    : ''
  },
  getters : {
    is_authenticated : state => {
      return state.is_authenticated;
    },
    auth_key : state => {
      return state.auth_key;
    },
    tray : state => {
      return state.tray;
    },
    tray_qty : state => {
      return state.tray_qty;
    },
    tray_length : state => {
      return state.tray.length;
    },
    printer_uri : state => {
      return state.printer_uri;
    },
    printer_uri_local : state => {
      return state.printer_uri_local;
    },
    printer_location : state => {
      return state.printer_location;
    },
    report_dates : state => {
      return {
        from : state.report_date_from,
        to   : state.report_date_to
      };
    },
    user : state => {
      return state.user;
    }
  },
  mutations : {
    addToTray(state, payload){
      state.tray.push(payload);
      state.tray_qty += payload.supply_qty;
    },
    removeFromTray(state, payload){
      state.tray.splice(payload, 1);
    },
    clearTray(state, payload){
      state.tray = [];
    },
    updateReportDates(state, payload){
      state.report_date_from = payload.from;
      state.report_date_to   = payload.to;
    },
    updateAuthToken(state, payload){
      state.auth_key = payload.new_auth_key;
    },
    performLogIn(state, data){
      let token = data.token;
      state.is_authenticated = true;
      state.auth_key = token;
      // delete data.token;
      state.user = data;
    },
    logOut(state){
      state.is_authenticated = false;
      state.auth_key = '';
      state.user = {};
    }
  },
  actions : {
    logIn({ commit }, payload){
      return new Promise((resolve, reject) => {
        Vue.http.post('users/login', payload)
          .then((response) => {
            if(response.body.status === 'success'){
              response.body.data.location = payload.location;
              commit('performLogIn', response.body.data);
              resolve();
            } else {
              reject(response.body.message);
            }
          }, (error) => {
            reject(error);
          });
      })
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/store.js